import type { FC, PropsWithChildren } from "react";
import { useAuthInitializer } from "./hooks";

export const AuthInitializer: FC<PropsWithChildren> = ({ children }) => {
  useAuthInitializer();

  return <>{children}</>;
};
